import config from '@/config/prod.env';
import { header } from '@/helper/header';
import { common } from '@/helper/common';

export const basicService = {
    queryData,
    executeData,
    importExcel
};

async function queryData(params, tableName){
    const requestOptions = {
        method: 'POST',
        headers: await header.authHeaderWithToken(),
        body: JSON.stringify(params)
    };
    return await fetch(`${config.API_URL}/${tableName}/QueryData`, requestOptions).then(response => common.handleResponse(response));
}

async function executeData(item, type, tableName) {
    // type == 0 ---> Form
    // type == 1 ---> Json
    if (type == 0)
        return await executeFormData(item, tableName);
    else if(type == 1)
        return await executeListData(item, tableName);
}

async function executeListData(item, tableName) {
    const requestOptions = {
        method: 'POST',
        headers: await header.authHeaderWithToken(),
        body: JSON.stringify(item)
    };
    return await fetch(`${config.API_URL}/${tableName}/ExecuteData`, requestOptions).then(response => common.handleResponse(response));
}

async function executeFormData(item, tableName) {
    var formData = new FormData();
    for (var propertyName in item) {
        if (Object.prototype.hasOwnProperty.call(formData, propertyName) == false) {
            formData.append(propertyName, item[propertyName]);
        }
    }
    const requestOptions = {
        method: 'POST',
        headers: await header.authHeaderWithTokenFormData(),
        body: formData
    };
    return await fetch(`${config.API_URL}/${tableName}/ExecuteFormData`, requestOptions).then(response => common.handleResponse(response));
}

async function importExcel(item, tableName) {
    const requestOptions = {
        method: 'POST',
        headers: await header.authHeaderWithToken(),
        body: JSON.stringify(item.listData)
    };
    return await fetch(`${config.API_URL}/${tableName}/ImportExcel`, requestOptions).then(response => common.handleResponse(response));
}